import { AuthEffects } from '@/app/+state/auth/auth.effects';
import { reducers } from '@/app/+state/reducers';
import { preset } from '@/app/app.preset';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { Router, provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Dialog } from '@angular/cdk/dialog';
import { APP_CONFIG } from '@environments/environment';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { MessageService, ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { ChallengeInterceptor } from './core/interceptors/challenge.interceptor';
import { FingerprintInterceptor } from './core/interceptors/fingerprint.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ChallengeInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: FingerprintInterceptor, multi: true },
        provideAnimations(),
        providePrimeNG({
            theme: {
                preset: preset,
                options: {
                    darkModeSelector: false,
                },
            },
        }),
        provideStore(reducers),
        provideEffects([AuthEffects]),
        provideStoreDevtools({
            maxAge: 25,
            logOnly: APP_CONFIG.production,
            connectInZone: true,
        }),
        provideAngularSvgIcon(),
        //{ provide: ErrorHandler, useClass: GlobalErrorHandler },
        MessageService,
        ConfirmationService,
        Dialog,
    ],
};
